import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import _ from "lodash";
import { Modal, DropdownButton, Dropdown } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  openDashboardUserExportModal,
  fetchDownloadUsersInfo,
  downloadUserPdf,
} from "DashboardUserAction";
import { COMMON_FAIL_MESSAGE, MAIN_URL } from "Constants";
import LocaleStrings from "Languages";
var Loader = require("react-loaders").Loader;

class ExportUsers extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);

    this.state = { loading: false };
  }

  openModal(e, key) {
    this.setState({ loading: false });
    this.props.reset();
    this.props.openDashboardUserExportModal({ show: true, key: key });
  }

  closeModal() {
    this.props.openDashboardUserExportModal({ show: false, key: "" });
  }

  downloadCSV = () => {
    let { session } = this.props;

    this.setState({ loading: true });
    this.props.fetchDownloadUsersInfo(session, (response) => {
      if (response.success) {
        this.setState({ loading: false });
        this.closeModal();
        if (
          response.data &&
          response.data.result &&
          !_.isEmpty(response.data.result)
        ) {
          this.props.JSONToCSVConvertor(response.data.result, true);
        } else {
          this.props.showError(LocaleStrings.no_data_found);
        }
      } else {
        this.props.showError(COMMON_FAIL_MESSAGE);
        this.setState({ loading: false });
      }
    });
  };

  downloadPdfF = (values) => {
    let { session } = this.props;

    this.setState({ loading: true });
    this.props.downloadUserPdf(session, values, (response) => {
      if (response.success) {
        this.setState({ loading: false });
        this.closeModal();

        var filename = "Users.pdf";
        var uri = `${MAIN_URL}/pdfgenerate/Users.pdf`;

        //this trick will generate a temp <a /> tag
        var link = document.createElement("a");
        link.href = uri;

        //set the visibility hidden so it will not effect on your web-layout
        link.style = "visibility:hidden";
        link.download = filename;
        link.target = "_blank";

        //this part will append the anchor tag and remove it after automatic click
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        this.props.showError(COMMON_FAIL_MESSAGE);
        this.setState({ loading: false });
      }
    });
  };

  renderLoader = () => {
    return (
      <Loader
        type="line-scale-pulse-out-rapid"
        active
        className="template-loader-div"
      />
    );
  };

  render() {
    let { loading } = this.state;
    let { handleSubmit, showModal, userList } = this.props;

    return (
      <div>
        <div className="dropdown-btn-container">
          <DropdownButton
            className="dropdown-white-btn"
            title={LocaleStrings.button_csv_export}
            key="1"
            id="dropdown-basic-1"
            nocaret="true"
          >
            <Dropdown.Item
              value="csv"
              onClick={(e) => this.openModal(e, "csv")}
            >
              {LocaleStrings.user_export_option_csv}
            </Dropdown.Item>
            {/* <Dropdown.Item
              value="pdf"
              onClick={(e) => this.openModal(e, "pdf")}
            >
              {LocaleStrings.user_export_option_pdf}
            </Dropdown.Item> */}
          </DropdownButton>
        </div>
        <div>
          <Modal
            className="modal-container"
            show={showModal.show === true ? true : false}
            onHide={this.closeModal}
            animation={true}
          >
            {showModal && showModal.show && showModal.key === "csv" ? (
              <>
                <Modal.Header>
                  <div className="import-modal-title">
                    {LocaleStrings.user_export_text_export_user}
                  </div>
                  <button
                    type="button"
                    className="i-custom-cross-popup pull-right"
                    onClick={() => this.closeModal()}
                  >
                    <img
                      className="i-custom-small"
                      src="../../style/images/custom-icons/cross-black.png"
                      alt="close"
                    />
                  </button>
                </Modal.Header>
                <Modal.Body>
                  <div style={{ textAlign: "center" }}>
                    {loading ? (
                      <div className="">
                        {this.renderLoader()}
                        <div className="loader-info">
                          {
                            LocaleStrings.user_export_text_export_user_csv_downloading
                          }
                        </div>
                      </div>
                    ) : (
                      <div className="">
                        {LocaleStrings.user_export_text_export_user_csv}
                        <p style={{ fontSize: "x-large" }}>
                          <span style={{ textTransform: "capitalize" }}>
                            {LocaleStrings.you}
                          </span>{" "}
                          {LocaleStrings.have} <b>{userList.count}</b>{" "}
                          {LocaleStrings.users}
                        </p>
                      </div>
                    )}
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  {userList.count > 0 ? (
                    <Button
                      type="button"
                      className="btn btn-custom-blue"
                      onClick={this.downloadCSV}
                      loading={loading}
                      disabled={loading}
                    >
                      {LocaleStrings.button_download}
                    </Button>
                  ) : (
                    <Button
                      className="btn btn-custom-white"
                      onClick={this.closeModal}
                    >
                      {LocaleStrings.sponsor_close}
                    </Button>
                  )}
                </Modal.Footer>
              </>
            ) : showModal && showModal.show && showModal.key === "pdf" ? (
              <form onSubmit={handleSubmit(this.downloadPdfF)}>
                <Modal.Header>
                  <div className="import-modal-title">Export User</div>
                  <button
                    type="button"
                    className="i-custom-cross-popup pull-right"
                    onClick={() => this.closeModal()}
                  >
                    <img
                      className="i-custom-small"
                      src="../../style/images/custom-icons/cross-black.png"
                      alt="close"
                    />
                  </button>
                </Modal.Header>
                <Modal.Body>
                  <div>
                    <div style={{ textAlign: "center" }}>
                      {LocaleStrings.user_export_text_export_user_pdf}
                      <p style={{ fontSize: "x-large" }}>
                        <span style={{ textTransform: "capitalize" }}>
                          {LocaleStrings.you}
                        </span>{" "}
                        {LocaleStrings.have} <b>{userList.count}</b>{" "}
                        {LocaleStrings.users}
                      </p>
                    </div>

                    <label className="control-label-top col-md-12"></label>
                    <div className="form-group row">
                      <div className="col-md-12" style={{ fontSize: 13 }}>
                        <Field
                          name="orientation"
                          component="input"
                          type="radio"
                          value="landscape"
                        />{" "}
                        {LocaleStrings.user_export_pdf_form_landscape}{" "}
                        <Field
                          name="orientation"
                          component="input"
                          style={{ marginLeft: 20 }}
                          type="radio"
                          value="portrait"
                        />{" "}
                        {LocaleStrings.user_export_pdf_form_portrait}
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-12" style={{ fontSize: 13 }}>
                        <Field name="fname" component="input" type="checkbox" />{" "}
                        {LocaleStrings.user_export_pdf_form_fname}
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-12" style={{ fontSize: 13 }}>
                        <Field name="lname" component="input" type="checkbox" />{" "}
                        {LocaleStrings.user_export_pdf_form_lname}
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-12" style={{ fontSize: 13 }}>
                        <Field
                          name="company"
                          component="input"
                          type="checkbox"
                        />{" "}
                        {LocaleStrings.company}
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-12" style={{ fontSize: 13 }}>
                        <Field
                          name="designation"
                          component="input"
                          type="checkbox"
                        />{" "}
                        {LocaleStrings.designation}
                      </div>
                    </div>
                    {/* <div className="form-group row">
                                            <div className="col-md-12" style={{fontSize: 13}}>
                                                <Field name="qr" component="input" type="checkbox"/> {LocaleStrings.qr}
                                            </div>
                                        </div> */}
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  {/* <Button className="button-theme" onClick={this.closeModal}>{LocaleStrings.button_close}</Button> */}
                  <Button
                    className="btn btn-custom-blue"
                    loading={loading}
                    disabled={loading}
                    type="submit"
                  >
                    {LocaleStrings.button_download}
                  </Button>
                </Modal.Footer>
              </form>
            ) : (
              ""
            )}
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showModal: state.ShowDashboardUserExportModal,
    userList: state.dashboardUserList,
  };
}

export default connect(mapStateToProps, {
  openDashboardUserExportModal,
  fetchDownloadUsersInfo,
  downloadUserPdf,
  showError,
  showSuccess,
})(
  reduxForm({
    form: "DownloadPdf",
    initialValues: {
      orientation: "landscape",
      fname: true,
      lname: true,
      company: true,
      designation: true,
      qr: true,
    },
  })(ExportUsers)
);
